module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_3009.0262f993.png";